import { useState } from "react";
import {
  Box,
  Button,
  InputAdornment,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { CustomInput } from "global/components";
import CustomDialog from "global/components/CustomDialog/CustomDialog";

interface CustomProps {
  title: string;
  id: string;
  value: string;
  name: string;
  onChange: Function;
  lengthOfValue?: string;
  description?: string;
  isVisible: boolean;
  btn1Title?: string;
  btn2Title?: string;
  btn1Variant?: "text" | "outlined" | "contained";
  btn2Variant?: "text" | "outlined" | "contained";
  btn1OnClick: Function;
  btn2OnClick: Function;
  isNavsHide?: boolean;
  handleDialogClose: Function;
}

const UserTemplateModal = (props: CustomProps) => {
  const theme = useTheme();
  const [error, setError] = useState(false);

  const handleSaveClick = async () => {
    if (!props.value.trim()) {
      setError(true);
    } else {
      setError(false);
      await props.btn2OnClick();
    }
  };

  const getDialogHeader = () => {
    return (
      <Box display="flex" justifyContent="center" pt={3}>
        <Typography variant="h4" color={theme.palette.primary.main}>
          {props.title}
        </Typography>
      </Box>
    );
  };

  const getBody = () => {
    return (
      <Box display="flex" flexDirection="column" justifyContent="center" p={1}>
        <CustomInput
          id={props.id}
          placeHolder="Enter template name"
          required
          type="text"
          name={props.name}
          value={props.value}
          onChange={(e: any) => {
            setError(false);
            props.onChange(e);
          }}
          propsToInputElement={{ maxLength: 40 }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <span style={{ fontSize: "0.75rem" }}>{props?.value?.length} / 40</span>
              </InputAdornment>
            ),
          }}
          error={error}
          sx={{
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: error ? "red" : "",
              },
              "&:hover fieldset": {
                borderColor: error ? "red" : "",
              },
              "&.Mui-focused fieldset": {
                borderColor: error ? "red" : theme.palette.primary.main,
              },
            },
          }}
        />
        {error && (
          <Typography color="error" variant="body2" margin={"3px 12px"}>
            Template name is required.
          </Typography>
        )}
      </Box>
    );
  };

  const getFooter = () => {
    return (
      <Stack direction="row" spacing={2}>
        <Button
          id="contacts_add__cancel_btn"
          variant={props.btn1Variant || "outlined"}
          sx={{ width: "7.125rem", height: "2.5rem" }}
          onClick={() => props.btn1OnClick()}
        >
          {props.btn1Title || "No"}
        </Button>
        <Button
          id="contacts_add_save_btn"
          variant={props.btn2Variant || "contained"}
          onClick={handleSaveClick}
          sx={{ width: "7.125rem", height: "2.5rem" }}
        >
          {props.btn2Title || "Yes"}
        </Button>
      </Stack>
    );
  };

  return (
    <CustomDialog
      handleDialogClose={props.handleDialogClose}
      isDialogOpen={props.isVisible}
      title={getDialogHeader()}
      body={getBody()}
      footer={getFooter()}
      closeButtonVisibility={true}
      closable
      isNavsHide={props.isNavsHide ?? false}
      maxWidth="sm"
      persistOnClickOutside
      persistOnEsc
    />
  );
};

export default UserTemplateModal;
